import React, { useCallback, useContext, useEffect } from 'react'
import { StandaloneFlightMenu } from 'components/Flights/FlightsSearch/SearchWidget/FlightSearchWidget'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import { addDays } from 'lib/datetime/dateUtils'

import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import { FlightsFareTypes } from 'constants/flight'
import FlightsDatePicker from './FlightsDatePicker/FlightsDatePicker'
import FlightDealDuration from 'components/Flights/FlightMerchandising/FlightDealDuration/FlightDealDuration'
import FlightSearchMenu from './FlightSearchMenu/FlightSearchMenu'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import SearchFormFieldGroup from 'components/SearchV2/Components/SearchFormField/SearchFormFieldGroup'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalContext from 'contexts/ModalContext'

interface Props {
  className?: string;
}

const earliestBookingDate = addDays(new Date(), 2)
const finalBookingDate = addDays(new Date(), 330)

function FlightSearchDateSelectMobile({ className }: Props) {
  const state = useContext(FlightSearchWidgetStateContext)
  const dispatch = useContext(FlightSearchWidgetDispatchContext)

  const {
    checkinDate,
    checkoutDate,
    fareType,
    flightDeal,
  } = state

  const showModal = useContext(ModalContext)

  const openMenu = useCallback(() => {
    dispatch({ type: FlightSearchWidgetActions.SET_ACTIVE_MENU, activeMenu: StandaloneFlightMenu.date })

    showModal(<FlightSearchMenu
      title="When do you want to go?"
    >
      <VerticalSpacer gap={24}>
        <FlightsDatePicker
          minDate={earliestBookingDate}
          maxDate={finalBookingDate}
          type="single"
        />
        {flightDeal && <FlightDealDuration flightDeal={flightDeal} />}
      </VerticalSpacer>
    </FlightSearchMenu>,
    ).finally(() => {
      dispatch({ type: FlightSearchWidgetActions.SET_ACTIVE_MENU, activeMenu: undefined })
    })
  }, [dispatch, flightDeal, showModal])

  useEffect(() => {
    if (fareType.value === FlightsFareTypes.ONE_WAY) {
      dispatch({ type: FlightSearchWidgetActions.SET_CHECKOUT_DATE, date: null })
    }
  }, [dispatch, fareType.value])

  return (
    <SearchFormFieldGroup className={className}>
      <SearchFormField
        label="Departing"
        placeholder="Select date"
        required
        requiredErrorMessage="Please select travel dates"
        value={checkinDate?.format(DMY_CASUAL_FORMAT)}
        onClick={openMenu}
      />
      {fareType.value === FlightsFareTypes.RETURN && <SearchFormField
        label="Returning"
        placeholder="Select date"
        required
        requiredErrorMessage="Please select travel dates"
        value={checkoutDate?.format(DMY_CASUAL_FORMAT)}
        onClick={openMenu}
      />}
    </SearchFormFieldGroup>
  )
}

export default FlightSearchDateSelectMobile
